// import {createSelector, createSlice} from '@reduxjs/toolkit';
// import {fetchOrderPageData, submitFinishing, updateOrderOptions} from './orderDetailsActions';
// import {
//     calculateAdditionalPrice,
//     haveTotalsChanged
// } from "../../components/CustomerPortalComponent/OrderDetails/utils/helpers";
// import {logOut} from "../user/userSlice";
//
// /* ---------- helpers ---------- */
// const buildToggleState = order => ({
//     includeHardware: order.includeHardware === 'true',
//     includeAssembly: order.includeAssembly === 'true',
//     includeFinishing: order.includeFinishing === 'true',
//     includeDrawerboxes: order.includeDrawerboxes === 'true'
// });
//
// /* ---------- slice ---------- */
// const orderDetailsSlice = createSlice({
//     name: 'orderDetails',
//     initialState: {byId: {}},
//     reducers: {
//         clearOrderCache: (state, action) => {
//             const orderId = action.payload;
//             if (state.byId[orderId]) {
//                 delete state.byId[orderId];
//             }
//         },
//         // Clear all order caches
//         clearAllOrderCaches: (state) => {
//             state.byId = {};
//         }
//     },
//     extraReducers: builder => {
//         /* ----- page fetch ----- */
//         builder
//             .addCase(fetchOrderPageData.pending, (s, {meta}) => {
//                 s.byId[meta.arg.orderId] = {...s.byId[meta.arg.orderId], loading: 'pending'};
//             })
//             .addCase(fetchOrderPageData.fulfilled, (s, {payload}) => {
//                 const {orderId, order, status, invoiceData} = payload;
//                 const toggles = buildToggleState(order);
//
//                 s.byId[orderId] = {
//                     order,
//                     status,
//                     invoiceData,
//                     toggles,
//                     finishing: {
//                         finishingType: order.finishingType || 'Matte',
//                         finishingColor: order.finishingColor || ''
//                     },
//                     additionalPrice: calculateAdditionalPrice(invoiceData),
//                     totalsChanged: haveTotalsChanged(order, toggles, toggles),
//                     loading: 'succeeded',
//                     error: null,
//                     fetchedAt: Date.now()   // stamp this fetch for TTL checks
//
//                 };
//             })
//             // .addCase(fetchOrderPageData.rejected, (s, {payload, meta}) => {
//             //     // const orderId = payload?.orderId || meta.arg.orderId;
//             //     // s.byId[orderId] = {...s.byId[orderId], loading: 'failed', error: payload?.reason};
//             // });
//             .addCase(fetchOrderPageData.rejected, (state, {payload, meta}) => {
//                 const orderId = payload?.orderId ?? meta.arg.orderId;
//                 state.byId[orderId] = {
//                     ...state.byId[orderId],
//                     loading: 'failed',
//                     error: payload?.reason || 'Unknown error'
//                 };
//             })
//
//
//         /* ----- option toggle ----- */
//         builder.addCase(updateOrderOptions.fulfilled, (s, {payload}) => {
//             const slice = s.byId[payload.orderId];
//             slice.invoiceData = payload.invoiceData;
//             slice.toggles = {
//                 includeHardware: payload.options.includeHardware === 'true',
//                 includeAssembly: payload.options.includeAssembly === 'true',
//                 includeFinishing: payload.options.includeFinishing === 'true',
//                 includeDrawerboxes: payload.options.includeDrawerboxes === 'true'
//             };
//             slice.additionalPrice = calculateAdditionalPrice(payload.invoiceData);
//             slice.totalsChanged = haveTotalsChanged(slice.order, buildToggleState(slice.order), slice.toggles);
//         });
//
//         /* ----- finishing ----- */
//         builder.addCase(submitFinishing.fulfilled, (s, {payload}) => {
//             const slice = s.byId[payload.orderId];
//             slice.finishing = {finishingType: payload.finishingType, finishingColor: payload.finishingColor};
//             slice.order.finishingType = payload.finishingType;
//             slice.order.finishingColor = payload.finishingColor;
//             slice.invoiceData = payload.invoiceData;
//             slice.additionalPrice = calculateAdditionalPrice(payload.invoiceData);
//         });
//         builder.addCase(logOut, (state) => {
//             state.byId = {};
//         });
//     }
// });
//
// export const {clearOrderCache, clearAllOrderCaches} = orderDetailsSlice.actions;
//
// export default orderDetailsSlice.reducer;
//
// /* ---------- selectors ---------- */
// export const selectOrderSlice = (state, orderId) => state.orderDetails.byId[orderId] || {};
// export const makeSelectAdditionalPrice = orderId =>
//     createSelector(state => selectOrderSlice(state, orderId).additionalPrice, p => p ?? 0);
// export const makeSelectTotalsChanged = orderId =>
//     createSelector(state => selectOrderSlice(state, orderId).totalsChanged, t => !!t);


import {createSelector, createSlice} from '@reduxjs/toolkit';
import {fetchOrderPageData, submitFinishing, updateOrderOptions} from './orderDetailsActions';
import {
    calculateAdditionalPrice,
    haveTotalsChanged
} from "../../components/CustomerPortalComponent/OrderDetails/utils/helpers";
import {logOut} from "../user/userSlice";

/* ---------- helpers ---------- */
const buildToggleState = order => ({
    includeHardware: order.includeHardware === 'true',
    includeAssembly: order.includeAssembly === 'true',
    includeFinishing: order.includeFinishing === 'true',
    includeDrawerboxes: order.includeDrawerboxes === 'true'
});

/* ---------- slice ---------- */
const orderDetailsSlice = createSlice({
    name: 'orderDetails',
    initialState: {byId: {}},
    reducers: {
        // Clear cache for a specific order
        clearOrderCache: (state, action) => {
            const orderId = action.payload;
            if (state.byId[orderId]) {
                delete state.byId[orderId];
            }
        },
        // Clear all order caches
        clearAllOrderCaches: (state) => {
            state.byId = {};
        }
    },
    extraReducers: builder => {
        /* ----- page fetch ----- */
        builder
            .addCase(fetchOrderPageData.pending, (s, {meta}) => {
                s.byId[meta.arg.orderId] = {...s.byId[meta.arg.orderId], loading: 'pending'};
            })
            .addCase(fetchOrderPageData.fulfilled, (s, {payload}) => {
                const {orderId, order, status, invoiceData} = payload;
                const toggles = buildToggleState(order);

                s.byId[orderId] = {
                    order,
                    status,
                    invoiceData,
                    toggles,
                    finishing: {
                        finishingType: order.finishingType || 'Matte',
                        finishingColor: order.finishingColor || ''
                    },
                    additionalPrice: calculateAdditionalPrice(invoiceData),
                    totalsChanged: haveTotalsChanged(order, toggles, toggles),
                    loading: 'succeeded',
                    error: null,
                    fetchedAt: Date.now()   // stamp this fetch for TTL checks

                };
            })
            .addCase(fetchOrderPageData.rejected, (state, {payload, meta}) => {
                const orderId = payload?.orderId ?? meta.arg.orderId;
                state.byId[orderId] = {
                    ...state.byId[orderId],
                    loading: 'failed',
                    error: payload?.reason || 'Unknown error'
                };
            })

        /* ----- option toggle ----- */
        builder.addCase(updateOrderOptions.fulfilled, (s, {payload}) => {
            const slice = s.byId[payload.orderId];
            slice.invoiceData = payload.invoiceData;
            slice.toggles = {
                includeHardware: payload.options.includeHardware === 'true',
                includeAssembly: payload.options.includeAssembly === 'true',
                includeFinishing: payload.options.includeFinishing === 'true',
                includeDrawerboxes: payload.options.includeDrawerboxes === 'true'
            };
            slice.additionalPrice = calculateAdditionalPrice(payload.invoiceData);
            slice.totalsChanged = haveTotalsChanged(slice.order, buildToggleState(slice.order), slice.toggles);
        });

        /* ----- finishing ----- */
        builder.addCase(submitFinishing.fulfilled, (s, {payload}) => {
            const slice = s.byId[payload.orderId];
            slice.finishing = {finishingType: payload.finishingType, finishingColor: payload.finishingColor};
            slice.order.finishingType = payload.finishingType;
            slice.order.finishingColor = payload.finishingColor;
            slice.invoiceData = payload.invoiceData;
            slice.additionalPrice = calculateAdditionalPrice(payload.invoiceData);
        });
        builder.addCase(logOut, (state) => {
            state.byId = {};
        });
    }
});

// Export the action creators
export const {clearOrderCache, clearAllOrderCaches} = orderDetailsSlice.actions;

export default orderDetailsSlice.reducer;

/* ---------- selectors ---------- */
export const selectOrderSlice = (state, orderId) => state.orderDetails.byId[orderId] || {};
export const makeSelectAdditionalPrice = orderId =>
    createSelector(state => selectOrderSlice(state, orderId).additionalPrice, p => p ?? 0);
export const makeSelectTotalsChanged = orderId =>
    createSelector(state => selectOrderSlice(state, orderId).totalsChanged, t => !!t);